// @flow

import * as React from "react"
import Modal from "react-modal"
import {withTranslation} from "react-i18next"
import {connect} from "react-redux"
import {includes} from "lodash"
import ClassNames from "classnames"

import Icon from "../icon"
import {getShopItemMedia, updateShopItemMedia} from "../../actions/shop"
// import {post} from '../../client'
import Config from "../../config"
// import {updateShopItem} from '../../actions/shop'
import type {Dispatch, Media, ShopItem, State as ReduxState} from "../../types"

type Props = {
  +t: any,
  +item: ShopItem,
  +babyToken: string,
  +dispatch: Dispatch,
  +shopItemMedia: $ReadOnlyArray<Media>,
  +babyMedia: $ReadOnlyArray<Media>,
  +onClose: () => void,
}

type State = {
  +item: any,
  +selectedMedia: $ReadOnlyArray<number>,
}

class ShopAdminMediaModal extends React.Component<Props, State> {
  handleSave: (SyntheticEvent<*>) => void
  handleMediaClick: (number) => void

  constructor(props: Props) {
    super(props)

    Modal.setAppElement("#app")

    this.state = {
      item: {
        ...props.item,
      },
      selectedMedia: props.item.media.map((m) => m.mediaId),
    }

    this.handleSave = this.handleSave.bind(this)
    this.handleMediaClick = this.handleMediaClick.bind(this)
  }

  componentDidMount() {
    const {
      dispatch,
      babyToken,
      item: {id},
    } = this.props
    dispatch(getShopItemMedia(babyToken, id))
  }

  handleMediaClick(mediaId: number) {
    const {selectedMedia} = this.state
    this.setState({
      selectedMedia: includes(selectedMedia, mediaId)
        ? selectedMedia.filter((i) => i !== mediaId)
        : [...selectedMedia, mediaId],
    })
  }

  handleSave(e: SyntheticEvent<*>) {
    e.preventDefault()
    const {
      dispatch,
      item: {id},
      babyToken,
      onClose,
    } = this.props
    dispatch(updateShopItemMedia(babyToken, id, this.state.selectedMedia))
    onClose()
  }

  renderMediaList(type: string, media: $ReadOnlyArray<Media>) {
    const {selectedMedia} = this.state
    if (media.length == 0) {
      return (
        <div className="mb-4 text-gray">
          <em>No media found</em>
        </div>
      )
    }
    return (
      <ul className="shop-item-media-list">
        {media.map((m) => {
          const key = `${type}-${m.id}`
          const className = ClassNames("shop-item-media-list-item", {
            "is-selected": includes(selectedMedia, m.id),
          })
          return (
            <li
              key={key}
              className={className}
              onClick={() => this.handleMediaClick(m.id)}
            >
              <Icon name="icon-check" />
              <div className="shop-item-media-list-image">
                <img src={m.sizes.medium} alt={m.title} />
              </div>
            </li>
          )
        })}
      </ul>
    )
  }

  renderBody() {
    const {t, shopItemMedia, babyMedia} = this.props
    return (
      <div>
        <div>
          <h2 className="font-weight-light mb-1">
            {t(`shopAdmin.media.product`)}
          </h2>
          {this.renderMediaList("product", shopItemMedia)}
        </div>
        <div>
          <h2 className="font-weight-light mb-1">
            {t(`shopAdmin.media.baby`)}
          </h2>
          {this.renderMediaList("baby", babyMedia)}
        </div>
        <button
          className="btn btn-primary"
          type="button"
          onClick={this.handleSave}
        >
          {t(`shopAdmin.modal.save`)}
        </button>
      </div>
    )
  }

  render() {
    const {t, onClose} = this.props
    return (
      <Modal
        className="modal-dialog modal-lg"
        isOpen={true}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={onClose}
        contentLabel=""
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t(`shopAdmin.media.title`)}</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label={t("modal.close")}
              onClick={onClose}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div className="modal-body pt-0">{this.renderBody()}</div>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state: ReduxState) => ({
  babyToken: Config.data.babyToken,
  shopItemMedia: state.shop.shopItemMedia.shopItemMedia,
  babyMedia: state.shop.shopItemMedia.babyMedia,
})

export default withTranslation()(connect(mapStateToProps)(ShopAdminMediaModal))
